import { render, staticRenderFns } from "./SuggestionsAndCommentsView.vue?vue&type=template&id=faf995b2&scoped=true"
import script from "./SuggestionsAndCommentsView.vue?vue&type=script&lang=js"
export * from "./SuggestionsAndCommentsView.vue?vue&type=script&lang=js"
import style0 from "./SuggestionsAndCommentsView.vue?vue&type=style&index=0&id=faf995b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf995b2",
  null
  
)

export default component.exports